import { Suspense } from 'react';
import { Skeleton } from '@sara/ui/components/skeleton';
import { QueryErrorBoundary } from '@sara/ui/components/query-error-boundary';
import { useSuspenseQuery } from '@tanstack/react-query';
import { getListExtractionsQueryOptions } from '@sara/api-client';
import { ExtractionList } from '../../components/ExtractionList/ExtractionList';
import { toSuspense } from '../../../../lib/query';
import { useOrgSlug } from '../../../auth';

interface ExtractionListContainerProps {
  orgId: string;
}

function ExtractionListSkeleton() {
  return (
    <div className="grid gap-3">
      <Skeleton className="h-[72px] rounded-lg" />
      <Skeleton className="h-[72px] rounded-lg" />
      <Skeleton className="h-[72px] rounded-lg" />
    </div>
  );
}

function ExtractionListContainerContent({ orgId }: ExtractionListContainerProps) {
  const { data } = useSuspenseQuery(toSuspense(getListExtractionsQueryOptions({ orgId })));
  const orgSlug = useOrgSlug();

  return (
    <ExtractionList
      extractions={data}
      getLinkProps={(extraction) => ({
        to: '/orgs/$orgSlug/extractions/$extractionId',
        params: { orgSlug, extractionId: extraction.id },
      })}
    />
  );
}

export function ExtractionListContainer({ orgId }: ExtractionListContainerProps) {
  return (
    <QueryErrorBoundary>
      <Suspense fallback={<ExtractionListSkeleton />}>
        <ExtractionListContainerContent orgId={orgId} />
      </Suspense>
    </QueryErrorBoundary>
  );
}
